const CARD_API_BASE = 'https://deckofcardsapi.com/static/img';

const normalizeCardCode = (code: string) => {
  if (!code) return '';
  const trimmed = code.trim().toUpperCase();
  if (trimmed.startsWith('10')) {
    return `0${trimmed.slice(2)}`;
  }
  if (trimmed.length === 2 && trimmed.startsWith('T')) {
    return `0${trimmed.slice(1)}`;
  }
  return trimmed;
};

export const getCardApiImageUrl = (code: string) => {
  const normalized = normalizeCardCode(code);
  if (!normalized) return `${CARD_API_BASE}/back.png`;
  return `${CARD_API_BASE}/${normalized}.png`;
};

export const getCardApiBackUrl = () => `${CARD_API_BASE}/back.png`;
